import "./slider_f41b/slider_f41b.js";
import "./slider_c739/slider_c739.js";
import "./image_gallery_popup/image_gallery_popup.js";
import "./video_ceb4/video_ceb4.js";
import "./hero_e132/hero_e132.js";
import "./posts_f063/posts_f063.js";
import "./accordion/accordion_cd7c.js";
import "./gallery/gallery_b10f.js";
import "./slider_scroll/slider_scroll.js";
import "./post_grid/post_slider.js";
import "./slider_scroll_mob_only/slider_scroll_mob_only.js";
import "./tab_content/tab_content.js";
import "./newsletter_signup/newsletter_signup.js";
import "./calculator_loan/calculator_loan.js";
import "./calculator_cashflow/calculator_cashflow.js";
import "./calculator_interest/calculator_interest.js";
import "./calculator_refinance/calculator_refinance.js";
import "./calculator_retirement/calculator_retirement.js";
import "./reviews_slider/reviews_slider.js";
import "./print/pdf_print.js";
import "./homepage_slider/homepage_slider.js";
import "./fade_animation/fade_animation.js"
import "./gallery/gallery.js"
import "./form_c7c0/form_enquire.js"
import "./service_slider/service_slider.js"
import "./tab/tab.js"
import "./card_stats/card_stats.js"
import "./card_reviews/card_reviews.js"
import "./card_switcher/card_switcher.js"
import "./hero_banner_dynamictext/hero_banner_dynamictext.js"
import "./text_teamslider/text_teamslider.js"
// import "./text_teamslider/text_teamslider_mz.js"
import "./teamslider/teamslider.js"
import "./desk_grid_mob_slider/desk_grid_mob_slider.js"
import "./calculators_slider/calculators_slider.js"